import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './io-state-icon.module.css'

const propTypes = {
    active: PropTypes.bool
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    active: false,
    viewBoxSize: 48
}

const backgroundPath = 'M24,2A22,22,0,0,0,3.51,16H7.9a18,18,0,1,1,0,16H3.51A22,22,0,1,0,24,2Z'
const iconPath = 'M14,30l10.06-6L14,18v4H2v4H14v4Z'

/**
 * Stateless function representing a input icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <InputIcon width={12} />
 */
const InputIcon = props => {
    const { active } = props

    const arrowClass = active ? styles['active-state'] : ''

    return (
        <SvgIcon {...props}>
            <path d={backgroundPath} />
            <path className={arrowClass} d={iconPath} />
        </SvgIcon>
    )
}

InputIcon.defaultProps = defaultProps
InputIcon.propTypes = propTypes

export { InputIcon }
